// @flow
import React, { useEffect, useState, useCallback, useMemo } from 'react'
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import PropTypes from 'prop-types';


export default function MsgDialog(props) {

  const open = props.open || false
  const title = props.title || ""
  const msgText = props.msgText || ""
  const onClose = props.onClose

  const handleCloseClick = () => {
    onClose && onClose();
  }



  return (
    <Dialog
      open={open}
      // onClose={handleCloseClick}
      fullWidth={true}
      // minWidth={"lg"}
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description" >
          {msgText}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseClick}>Close</Button>
      </DialogActions>
    </Dialog>

  );
}

MsgDialog.propTypes = {
  open: PropTypes.bool,
  title: PropTypes.string,
  msgText: PropTypes.string,
  onClose: PropTypes.func,
};
